import Vue from "vue";
import VueCookies from "vue-cookies";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { i18n } from "./plugins/i18n";
import * as moment from "moment";

Vue.use(VueCookies);
Vue.filter("formatTime", value => moment(value, "HH:mm").format("HH:mm"));
Vue.filter(
  "formatDate",
  (value) => `${moment(value).format("dddd")}, ${moment(value).format("LL")}`
);

Vue.config.productionTip = false;

[...new Set(window.eventScheduleWidgetIds)].forEach((id) => {
  new Vue({
    vuetify,
    i18n,
    render: h => h(App, { props: { widgetId: id } })
  }).$mount(`#${id}`);
});
